import '~/lib/tiptap/styles/highlight.scss'
import * as React from 'react'
import { NodeViewContent, NodeViewWrapper, NodeViewProps } from '@tiptap/react'
import { LANGUAGES } from '@basehub/shared-constants'
import { CodeSnippetControls } from '~/app/(dash)/[team-slug]/(repo)/[repo-slug]/(editor)/explore/components/blocks/code-snippet/controls'
import { prettierAllowedLanguages } from '@basehub/utils/format'

export const CodeBlockWrapper = ({
  node,
  updateAttributes,
  editor,
  getPos,
}: NodeViewProps) => {
  const selectedLanguage =
    (node.attrs.language as keyof typeof LANGUAGES) ?? 'plainText'
  const preRef = React.useRef<HTMLPreElement>(null)

  return (
    <NodeViewWrapper className="code-block relative">
      <div
        className="absolute select-none top-0 right-0 p-1 flex items-start gap-0.5"
        contentEditable={false}
      >
        <CodeSnippetControls
          formatting={
            prettierAllowedLanguages.includes(selectedLanguage)
              ? {
                  code: () => preRef.current?.innerText ?? '',
                  lang: selectedLanguage,
                  onFormat: (result) => {
                    editor
                      .chain()
                      .focus()
                      .insertContentAt(
                        {
                          from: getPos(),
                          to: getPos() + node.nodeSize,
                        },
                        {
                          type: node.type.name,
                          attrs: {
                            language: selectedLanguage as string,
                          },
                          content: [
                            {
                              type: 'text',
                              text: result,
                            },
                          ],
                        }
                      )
                      .setTextSelection(editor.state.selection.from)
                      .run()
                  },
                }
              : undefined
          }
          copyContent={() => {
            return preRef.current?.innerText ?? ''
          }}
          languageSelector={{
            value: selectedLanguage,
            onValueChange: (value: string) =>
              updateAttributes({ language: value }),
            options: Object.entries(LANGUAGES).map(([key, value]) => ({
              value: key,
              label: value.label,
            })),
          }}
        />
      </div>
      <pre data-language={node.attrs.language} ref={preRef}>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  )
}
